import React from 'react';
import Link from '../../link';
import useIsThinLayout from '../../../hooks/use-is-thin-layout';

interface Props {
  title: string;
  subtitle?: string;
  breadcrumb: Breadcrumbs;
  fullWidth?: boolean;
}

interface Breadcrumbs {
  url: string;
  text: string;
}

const GenericContainer: React.FC<Props> = ({
  title,
  subtitle,
  breadcrumb,
  fullWidth = false,
  children,
}) => {
  const { isThinLayout } = useIsThinLayout();

  return (
    <section>
      <div className="generic-layout">
        <div className="title">
          {isThinLayout ? null : (
            <div className="breadcrumb">
              <Link href={breadcrumb.url}>
                <a>
                  <i className="fas fa-long-arrow-alt-left" /> {breadcrumb.text}
                </a>
              </Link>
            </div>
          )}
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {children}
      </div>
      {/* language=CSS */}
      <style jsx>{`
        section {
          width: 100%;
        }

        .generic-layout {
          display: flex;
          flex-wrap: wrap;
          flex-direction: row;
          justify-content: space-between;
          width: 100%;
        }

        @media screen and (max-width: 850px) {
          .generic-layout {
            padding: 2rem;
            gap: 1rem;
          }
        }

        .generic-layout .title {
          flex: 1 0 ${fullWidth ? '100%' : '40%'};
        }

        @media screen and (max-width: 850px) {
          .generic-layout .title {
            flex: 1 0 100%;
          }
        }

        .title h2 {
          margin: 0;
          font-family: 'Volvo Novum', sans-serif;
          font-weight: 400;
        }

        .title p {
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
        }

        .generic-layout > :global(.content) {
          flex: 1 0 ${fullWidth ? '100%' : '60%'};
        }

        @media screen and (max-width: 850px) {
          .generic-layout > :global(.content) {
            flex: 1 0 100%;
          }
        }

        .breadcrumb {
          margin-bottom: 1rem;
          font-size: 14px;
          font-family: 'Volvo Novum', sans-serif;
        }

        .breadcrumb a {
          color: #333;
          text-decoration: none;
          transition: all 0.2s linear;
        }

        .breadcrumb a:hover {
          color: #707070;
        }
      `}</style>
    </section>
  );
};

export default GenericContainer;
